import axios from "axios";
export const state = {
    factory_stock: [],
    production_factories: [],
    filter_status: false,
    save_status: false,
    disbursement_cart: [],
    disbursements: [],
    stockreturn_cart: [],
    pendingspoilt: [],
    stockreturns: [],
    stockvalue: [],
    factory_disbursements: [],
    reconcilations: [],
    stock_movements:[],
    factory_production_batches:[]
};
export const getters = {
    FactoryStock: state => state.factory_stock.data,
    ProductionFactories: state => state.production_factories,
    FilterStatus: state => state.filter_status,
    SaveStatus: state => state.save_status,
    DisbursementCart: state => state.disbursement_cart.data,
    Disbursements: state => state.disbursements.data,
    StockreturnCart: state => state.stockreturn_cart.data,
    PendingSpoilt: state => state.pendingspoilt.data,
    Stockreturns: state => state.stockreturns.data,
    StockValue: state => state.stockvalue,
    FactoryDisbursements: state => state.factory_disbursements.data,
    Reconcilations: state => state.reconcilations.data,
    StockMovement: state => state.stock_movements.data,
    FactoryProductionBatches: state => state.factory_production_batches,
};

export const mutations = {
    SET_FACTORIES(state, newValue) {
        state.production_factories = newValue
    },
    SET_FACTORIESTOCK(state, newValue) {
        state.factory_stock = newValue
    },
    SET_FILTERSTATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_DISBURSEMENT_CART(state, newValue) {
        state.disbursement_cart = newValue
    },
    SET_DISBURSEMENTS(state, newValue) {
        state.disbursements = newValue
    },
    SET_FACTORY_DISBURSEMENTS(state, newValue) {
        state.factory_disbursements = newValue
    },
    SET_STOCKRETURN_CART(state, newValue) {
        state.stockreturn_cart = newValue
    },
    SET_PENDINGSPOILT(state, newValue) {
        state.pendingspoilt = newValue
    },
    SET_STOCKRETURNS(state, newValue) {
        state.stockreturns = newValue
    },
    SET_STOCKVALUE(state, newValue) {
        state.stockvalue = newValue
    },
    SET_RECONCILATIONS(state, newValue) {
        state.reconcilations = newValue
    },
    SET_STOCK_MOVEMENTS(state, newValue) {
        state.stock_movements = newValue
    },
    SET_FACTORY_PRODUCTION_BATCHES(state, newValue) {
        state.factory_production_batches = newValue
    },
};

export const actions = {

    fetchFactorystock({ commit }, id) {
        commit('SET_FILTERSTATUS', true)
        axios.get(`factory_stock/${id}`).then(ec_res => {
            commit('SET_FACTORIESTOCK', ec_res.data)
            commit('SET_FILTERSTATUS', false)
        })
    },

    fetchProductionFactories({ commit }) {
        axios.get('fetch_productionfactories').then(ec_res => {
            commit('SET_FACTORIES', ec_res.data)
        })
    },

    fetchFactorystockValue({ commit }) {
        commit('SET_FILTERSTATUS', true)
        axios.get(`factorystock_value`).then(ec_res => {
            commit('SET_STOCKVALUE', ec_res.data)
            commit('SET_FILTERSTATUS', false)
        })
    },

    // Stock roconciliation
    addQty({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`factory_reconciliation/${payload.product_id}`, payload).then(() => {
            dispatch('fetchFactorystock', payload.factory);
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
        })
    },

    SaveReconcile({ commit, dispatch }) {
        commit('SET_SAVE_STATUS', true);
        axios.post('save__factory_reconciliation').then(() => {
            let message = { 'msg': `Stock Reconciled successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Reconciling Stock" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchReconcilations({ commit }) {
        commit('SET_FILTERSTATUS', true)
        axios.get(`factory_reconciliation`).then(ec_res => {
            commit('SET_RECONCILATIONS', ec_res.data)
            commit('SET_FILTERSTATUS', false)
        })
    },

    fetchStockMovements({ commit }, payload) {
        commit('SET_FILTERSTATUS', true)
        axios.post('factory_stockmovement', payload).then(response => {
            commit('SET_FILTERSTATUS', false)
            commit('SET_STOCK_MOVEMENTS', response.data)
        })
    },

    fetchFactoryProductionBatches({ commit }, payload) {
        axios.post('fetch_factory_productionbatches',payload).then(response => {
            commit('SET_FACTORY_PRODUCTION_BATCHES', response.data)
        })
    },
};